import { useTranslate } from '@tolgee/react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const MoreInfoIcon = ({ text }) => {
  const { t } = useTranslate();
  return (
    <OverlayTrigger
      delay={{ show: 0, hide: 100 }}
      overlay={
        <Tooltip>
          <span className="text-gray-400 fw-bold d-block fs-7 text-start">
            {text}
          </span>
        </Tooltip>
      }
    >
      <i className="fa-regular fa-circle-info text-muted cursor-pointer"></i>
    </OverlayTrigger>
  );
};
export default MoreInfoIcon;
